import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';
import Footer from './Footer';

function NotFound() {
  return (
    <>
      <div className="not-found">
        <div className="not-found-container">
          <div className="not-found-content">
            <h1 className="not-found-title">404</h1>
            <h2 className="not-found-subtitle">Page Not Found</h2>
            <p className="not-found-description">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <div className="not-found-actions">
              <Link to="/" className="not-found-btn">
                Return Home
              </Link>
              <Link to="/team" className="not-found-btn-secondary">
                View Team
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default NotFound;
